export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10985.57ff9b9d.jpg";